/* Your card: nine things to do on sheckii.com, remembered in this browser only. No score.
   Other scripts call window.tpCard.mark('key') when someone does one of them. */
(function () {
  'use strict';
  var KEY = 'tp-card-v1';
  var HOLES = [
    { k: 'mini', t: 'Solve the Mini', href: '/#mini' },
    { k: 'holdout', t: 'Run a holdout test', href: '/#road-trip' },
    { k: 'quarters', t: 'Try a 70/20/10 budget', href: '/pages/70-20-10#quarters' },
    { k: 'friction', t: 'Read Friction by Design', href: '/pages/friction-by-design' },
    { k: 'yami', t: 'Read “Would they have bought anyway?”', href: '/pages/would-they-have-bought-anyway' },
    { k: 'listen', t: 'Play a podcast episode', href: '/pages/speaking#listen' },
    { k: 'record', t: 'See Tony on camera', href: '/pages/record' },
    { k: 'hire', t: 'Read the short version', href: '/pages/hire' },
    { k: 'fore', t: 'Find the hidden hole', href: '', hint: 'On a keyboard, type the word golfers yell. On a phone, tap the flag three times.' }
  ];
  var VISITS = { '/pages/friction-by-design': 'friction', '/pages/would-they-have-bought-anyway': 'yami', '/pages/record': 'record', '/pages/hire': 'hire' };

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function write(d) { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} }
  var listeners = [];
  var api = {
    holes: HOLES,
    get: function () { return read(); },
    mark: function (k) {
      var d = read(); if (d[k]) return;
      d[k] = Date.now(); write(d);
      listeners.forEach(function (fn) { try { fn(k); } catch (e) {} });
      publish('card_hole', { hole: k });
    },
    on: function (fn) { listeners.push(fn); }
  };
  window.tpCard = api;

  /* Site-wide click tracking for the actions that matter (the links page tracks its own). */
  function publish(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} }
  api.publish = publish;
  if (!document.body.classList.contains('template-links')) {
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href]'); if (!a) return;
      var href = a.getAttribute('href') || '', page = location.pathname, label = (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60);
      if (/cal\.com/i.test(href)) publish('book_call_click', { page: page, label: label });
      else if (/^mailto:/i.test(href)) publish('email_click', { page: page, address: href.replace(/^mailto:/i, '').split('?')[0] });
      else if (/Tony-Lee-Resume\.(pdf|docx)/i.test(href)) publish('resume_download', { page: page, format: /docx/i.test(href) ? 'docx' : 'pdf' });
      else if (/^https?:/i.test(href) && a.host !== location.host) {
        var dest = /substack/i.test(href) ? 'substack' : /spotify/i.test(href) ? 'podcast' : /linkedin/i.test(href) ? 'linkedin' : /instagram/i.test(href) ? 'instagram' : /youtube|youtu\.be/i.test(href) ? 'youtube' : /facebook/i.test(href) ? 'facebook' : a.host;
        publish('outbound_click', { page: page, destination: dest, label: label });
      }
    });
  }

  var path = location.pathname.replace(/\/$/, '');
  if (VISITS[path]) api.mark(VISITS[path]);
  document.addEventListener('tp:fore', function () { api.mark('fore'); });

  /* ---- the card at the bottom of the homepage ---- */
  var card = document.querySelector('[data-holed]');
  if (!card) return;
  var holesEl = card.querySelector('[data-card-holes]'), nextEl = card.querySelector('[data-card-next]'), sumEl = card.querySelector('[data-card-summary]');

  function render() {
    var d = read(), done = HOLES.filter(function (h) { return d[h.k]; }).length;
    holesEl.innerHTML = '';
    HOLES.forEach(function (h, i) {
      var li = document.createElement('li'), on = !!d[h.k];
      li.className = on ? 'is-done' : '';
      var label = (h.k === 'fore' && !on) ? h.t : h.t;
      li.innerHTML = '<span class="tp-card__n">' + (i + 1) + '</span>' + (h.href && !on ? '<a></a>' : '<span class="tp-card__t"></span>') + '<span class="tp-card__mark" aria-hidden="true">' + (on ? '✓' : '') + '</span>';
      var t = li.querySelector('a, .tp-card__t'); t.textContent = label; if (t.tagName === 'A') t.href = h.href;
      li.setAttribute('aria-label', label + (on ? ', done' : ', not yet'));
      holesEl.appendChild(li);
    });
    sumEl.textContent = done === 0 ? 'There are nine holes on this site. You’ve just finished the longest one.'
      : done === HOLES.length ? 'All nine. You’ve seen everything here, including the hidden one. Thank you, really.'
      : 'You’ve played ' + done + ' of the nine holes on this site.';
    var next = HOLES.filter(function (h) { return !d[h.k]; })[0];
    if (next && done < HOLES.length) {
      nextEl.hidden = false;
      nextEl.innerHTML = next.href ? 'Next up: <a class="textlink"></a>' : 'Still out there: <span></span>';
      var x = nextEl.querySelector('a, span'); x.textContent = next.href ? next.t : next.hint; if (next.href) x.href = next.href;
    } else nextEl.hidden = true;
  }
  api.on(render);
  render();

  /* What brought you here? */
  var email = card.getAttribute('data-email') || '', cal = card.getAttribute('data-calendar') || '';
  var ANSWERS = {
    hiring: { t: 'Here’s the version built for you: the roles I’m after, the experience behind them and my résumé.', links: [['The short version', '/pages/hire', 'gold'], cal ? ['Book a call', cal, 'line'] : null] },
    show: { t: 'I’d love to talk about your show or event. The speaking page has topics, bios and headshots.', links: [['Speaking & podcasts', '/pages/speaking', 'gold'], cal ? ['Book a call', cal, 'line'] : null] },
    old: { t: 'Then you already know how I work. It’s good to hear from you, so say hello.', links: [email ? ['Say hello', 'mailto:' + email + '?subject=Hello%20again', 'gold'] : null, ['What I’m doing now', '/pages/now', 'line']] },
    curious: { t: 'Glad you wandered in. I write about the other kind of growth every other Sunday.', links: [['Read Growth Sold Separately', 'https://sheckii.substack.com', 'gold'], ['Listen to the podcast', '/pages/speaking#listen', 'line']] }
  };
  var ans = card.querySelector('[data-why-answer]');
  function showWhy(k, remember) {
    var a = ANSWERS[k]; if (!a) return;
    card.querySelectorAll('[data-why]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-why') === k ? 'true' : 'false'); });
    ans.hidden = false;
    ans.innerHTML = '<p></p><div class="btn-row"></div>';
    ans.querySelector('p').textContent = a.t;
    a.links.filter(Boolean).forEach(function (l) {
      var el = document.createElement('a'); el.className = 'btn btn--' + l[2]; el.href = l[1]; el.textContent = l[0];
      if (/^https?:/.test(l[1])) { el.target = '_blank'; el.rel = 'noopener'; }
      ans.querySelector('.btn-row').appendChild(el);
    });
    if (remember) {
      try { localStorage.setItem('tp-why', k); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish('visitor_reason', { reason: k }); } catch (e) {}
    }
  }
  card.querySelectorAll('[data-why]').forEach(function (b) {
    b.setAttribute('aria-pressed', 'false');
    b.addEventListener('click', function () { showWhy(b.getAttribute('data-why'), true); });
  });
  try { var saved = localStorage.getItem('tp-why'); if (saved) showWhy(saved, false); } catch (e) {}

  /* Hidden hole on phones: tap the flag three times. */
  var flag = document.querySelector('.tp-green'), taps = [];
  if (flag) flag.addEventListener('click', function () {
    var now = Date.now(); taps = taps.filter(function (t) { return now - t < 1200; }); taps.push(now);
    if (taps.length >= 3) { taps = []; if (window.tpFore) window.tpFore(); else document.dispatchEvent(new CustomEvent('tp:fore')); }
  });

  /* If the 3D ball isn't running (reduced motion or no WebGL), show the card when the bottom comes into view. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        setTimeout(function () { if (!document.documentElement.classList.contains('tp-live') || !card.classList.contains('is-on')) { if (!document.documentElement.classList.contains('tp-live')) card.classList.add('is-on'); } }, 1500);
      });
    }, { threshold: 0.4 });
    io.observe(card);
  }
})();
